import { strapiInstance } from '@/constants/axios.instances.constants';
import { buildStrapiUrl, loadAbort } from '@/utils';
import { ofertasTrabajoListMapper } from '@/mappers';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import type { OfertaTrabajo, StrapiListRequest, StrapiResponse } from '@/interfaces/strapi';
import type { OfertaTrabajoModel, StrapiResponseModel } from '@/interfaces/model';

export const getJobOfferDetail = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiResponse<OfertaTrabajo>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/ofertas-de-trabajos',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<OfertaTrabajoModel>;
					const mapped = ofertasTrabajoListMapper(json);
					const first = mapped.list[0];
					return { data: first } satisfies StrapiResponse<OfertaTrabajo>;
				},
			],
		}),
		controller,
	};
};
